// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__fbtEm","heading":"FAQ_heading__Vq72U","markdown":"FAQ_markdown__OjlhC"};